import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import { useVehicleData } from './context';

const FuelEfficiencyCard = ({ selectedVehicleData, globalFilter, customFilter, setBestDayDate, benchmarkType }) => {
  const { GlobalData, setGlobalData } = useVehicleData();

  const { firstVinNo, secondVinNo } = selectedVehicleData
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [overallBestVehicle, setOverallBestVehicle] = useState("")
  const [depoVehicle, setDepoVehicle] = useState("")
  const [nationalBestVehicle, setNationalBestVehicle] = useState("")
  const [primaryVehicleDetails, setPrimaryVehicleDetails] = useState({})
  const [customVehicleDetails, setCustomVehicleDetails] = useState({})
  const [depoVehicleDetails, setDepoVehicleDetails] = useState({})
  const [nationalVehicleDetails, setNationalVehicleDetails] = useState({})


  const [vehicleData, setVehicleData] = useState({
    energyEfficiency: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
    energyEfficiencyScore: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
  })


  useEffect(() => {
    setGlobalData(prev => ({ ...prev, bestVehicle: overallBestVehicle, nationalVehicleId: nationalBestVehicle, bestDepoVehicleId: depoVehicle, energyEfficiency: vehicleData, primaryVehicleDetails, customVehicleDetails, depoVehicleDetails, nationalVehicleDetails }))
  }, [vehicleData, overallBestVehicle, depoVehicle, nationalBestVehicle, primaryVehicleDetails, customVehicleDetails, depoVehicleDetails, nationalVehicleDetails])

  // primary
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_energy_efficiency`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]
        setPrimaryVehicleDetails(data?.key)
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, primaryVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));


      }
    );

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_energy_efficiency_score`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, primaryVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));

      }
    );
  }, [firstVinNo.vehicleId, globalFilter])

  // best
  useEffect(() => {

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_best_driven_energy_efficiency`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {

        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, bestVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));
        setBestDayDate(data?.key?.eventdate)
        setOverallBestVehicle(data?.key?.eventdate)

      }
    );
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_best_energy_efficiency_score`,
        body: {
          filterdata: {
            ...globalFilter,
            bestDate: GlobalData?.bestVehicle,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]

        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, bestVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));
        setBestDayDate(data?.key?.eventdate)
      }
    )
  }, [firstVinNo.vehicleId, globalFilter, GlobalData?.bestVehicle])

  // secondary

  useEffect(() => {
    let energyEfficiencyAPiCustom = "mileage_analysis_energy_efficiency"
    let energyEfficiencyAPiDepot = "mileage_analysis_depo_energy_efficiency"
    let energyEfficiencyAPiNational = "mileage_analysis_national_energy_efficiency"

    let energyEfficiencyScoreAPiCustom = "mileage_analysis_energy_efficiency_score"
    let energyEfficiencyScoreAPiDepot = "mileage_analysis_depo_energy_efficiency_score"
    let energyEfficiencyScoreAPiNational = "mileage_analysis_national_energy_efficiency_score"

    setVehicleData(prev => ({
      energyEfficiency: { ...prev.energyEfficiency, secondaryVehicle: null },
      energyEfficiencyScore: { ...prev.energyEfficiencyScore, secondaryVehicle: null },
    }))

    // custom

    if (secondVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis/${energyEfficiencyAPiCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res[0]
          setCustomVehicleDetails(data?.key)
          setVehicleData(prevState => ({
            ...prevState,
            energyEfficiency: { ...prevState.energyEfficiency, secondaryVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
          }));

        }
      )

      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis/${energyEfficiencyScoreAPiCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res[0]
          setVehicleData(prevState => ({
            ...prevState,
            energyEfficiencyScore: { ...prevState.energyEfficiencyScore, secondaryVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
          }));

        }
      )
    }

    // depot
    let vinNoDepot = GlobalData?.bestDepoVehicleId ? [GlobalData?.bestDepoVehicleId] : []
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${energyEfficiencyAPiDepot}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res?.[0]
        setDepoVehicleDetails(data?.key)
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, depotVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));

        if (!res.length) {
          setDepoVehicle("")
        }
        else {
          setDepoVehicle(data.key.vehicleId)
        }

      }
    )

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${energyEfficiencyScoreAPiDepot}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": vinNoDepot,
          }
        }
      },
      (res) => {
        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, depotVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));

      }
    )

    // National

    let vinNonNational = GlobalData?.nationalVehicleId ? [GlobalData?.nationalVehicleId] : []
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${energyEfficiencyAPiNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res[0]
        setNationalVehicleDetails(data?.key)
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, nationalVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));
        setNationalBestVehicle(data?.key?.vehicleId) //MAT561005PMK00608
      }
    )

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${energyEfficiencyScoreAPiNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": vinNonNational,
          }
        }
      },
      (res) => {
        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, nationalVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));

      }
    )

  }, [secondVinNo?.vehicleId, GlobalData?.bestDepoVehicleId, GlobalData?.nationalVehicleId, customFilter, globalFilter, benchmarkType])


  const cardData = [
    {
      key: "energyEfficiency",
      name: "Energy Efficiency",
      unit: "KWh/Km"
    },
    {
      key: "energyEfficiencyScore",
      name: "Energy Efficiency Score",
      unit: ""
    }
  ]

  return (
    <div className="mb-0">
      {/* Fuel Efficiency Section */}

      {
        cardData.map((item, index) =>
          <div className="row mb-3" key={index}>
            <div className="col-12">
              <div className="row align-items-center">
                <div className="col-3">
                  <div className="d-flex align-items-center">
                    <h6 className={`mb-0 fw-bold me-2 ${styles.sectionTitle}`}>
                      {item.name} :
                    </h6>
                    {/* <Info size={14} className="text-muted" /> */}
                  </div>
                </div>
                <div className="col-3">
                  <div style={{ height: "40px" }} className={`p-3 d-flex justify-content-center align-items-center ${styles.dataCard}`}>
                    <span className={styles.dataValue}>
                      {vehicleData?.[item.key]?.primaryVehicle ? <>{vehicleData?.[item.key]?.primaryVehicle}{" " + item.unit}</> : <>--</>}
                    </span>
                  </div>
                </div>
                <div className="col-3">
                  <div style={{ height: "40px" }} className={`p-3 d-flex justify-content-center align-items-center ${styles.dataCard}`}>
                    <span className={styles.dataValue}>
                      {vehicleData?.[item.key]?.bestVehicle ? <>{vehicleData?.[item.key]?.bestVehicle}{" " + item.unit}</> : <>--</>}
                    </span>
                  </div>
                </div>
                <div className="col-3">
                  <div style={{ height: "40px" }} className={`p-3 d-flex justify-content-center align-items-center ${styles.dataCard}`}>
                    {
                      benchmarkType == "Custom" ?
                        <span className={styles.dataValue}>
                          {vehicleData?.[item.key]?.secondaryVehicle ? <>{vehicleData?.[item.key]?.secondaryVehicle}{" " + item.unit}</> : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>}
                        </span> :
                        benchmarkType == "National" ?
                          <span className={styles.dataValue}>
                            {vehicleData?.[item.key]?.nationalVehicle ? <>{vehicleData?.[item.key]?.nationalVehicle}{" " + item.unit}</> : <>--</>}
                          </span> :
                          <span className={styles.dataValue}>
                            {vehicleData?.[item.key]?.depotVehicle ? <>{vehicleData?.[item.key]?.depotVehicle}{" " + item.unit}</> : <>--</>}
                          </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default FuelEfficiencyCard;